import { useContext } from 'react';
import { UseGoogleMapsApiKey } from '../types/UseGoogleMapsApiKey';
import { GoogleMapsApiKeyContext } from '..';

export const useGoogleMapsApiKey = (): UseGoogleMapsApiKey => {
    return useContext<UseGoogleMapsApiKey>(GoogleMapsApiKeyContext);
};